import React from 'react';
import Routes from './routes';

import GithubCorner from './components/GithubCorner';

function App() {
  return (
    <div id="app">
      <GithubCorner />
      <Routes />
    </div>
  );
}

export default App;
